import APIService from '@/api';

export default class ForgotService extends APIService {
  newCustomerPassword(data: object) {
    return this.post('/customer/reset-password', data);
  }

  newBusinessPassword(data: object) {
    return this.post('/manager/reset-password', data);
  }

  forgotPassword(data: object) {
    return this.post('/manager/forgot-password/', data);
  }
}
